import './index.scss';

import { useEffect, useMemo, useRef, useState } from 'react';

import moment from 'moment';

const headbreaker = require('headbreaker');

const photos = [
  require('../../assets/images/puzzle.png'),
];

const waitFor = async (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

// add window.ReactNativeWebView to window
// to avoid 'window.ReactNativeWebView.postMessage is not a function'
// error
// use type assertion to avoid TypeScript error
// @ts-ignore
// window.ReactNativeWebView = window.ReactNativeWebView || {};
// use global

declare global {
  interface Window {
    ReactNativeWebView: any;
  }
}

const Main = () => {
  const didMount = useRef(false);
  const [reload, setReload] = useState(false);

  // const connect_audio = useRef(
  //   new Audio(require('../../assets/audios/connect.wav'))
  // );
  // const success_audio = useRef(
  //   new Audio(require('../../assets/audios/success.wav'))
  // );
  // const fail_audio = useRef(new Audio(require('../../assets/audios/fail.wav')));
  const canPlayClickAudio = useRef(true);

  const modeRef = useRef<'easy' | 'medium' | 'hard'>('easy');
  const mode = useMemo(() => {
    return modeRef.current;
  }, [modeRef.current]);
  const [showModeDialog, setShowModeDialog] = useState(false);
  const [showImageDialog, setShowImageDialog] = useState(false);
  const timeoutRef = useRef(1000 * 60);
  const timeout = useMemo(() => {
    return timeoutRef.current;
  }, [timeoutRef.current]);
  const countdownInterval = useRef<any>(null);
  const [countdownText, setCountdownText] = useState('');
  const isPlayingRef = useRef(false);
  const isPlaying = useMemo(() => {
    return isPlayingRef.current;
  }, [isPlayingRef.current]);

  const [current_photo, setCurrentPhoto] = useState<any>(photos[0]);

  useEffect(() => {
    didMount.current = true;
    changeMode(mode);
    isPlayingRef.current = false;
    load(current_photo, true);

    return () => {
      didMount.current = false;
    };
  }, []);

  const changeMode = (new_mode: typeof mode) => {
    modeRef.current = new_mode;
    switch (new_mode) {
      case 'easy':
        timeoutRef.current = 1000 * 60 * 1;
        break;
      case 'medium':
        timeoutRef.current = 1000 * 60 * 3;
        break;
      case 'hard':
        timeoutRef.current = 1000 * 60 * 6;
        break;
      default:
        break;
    }
    updateCountdownText();
    setShowModeDialog(false);
  };

  const onStartBtnClick = () => {
    changeMode(mode);
    startCountdown();
    isPlayingRef.current = true;
    load(current_photo, false);
    //
    sendAdvertize(getModeNumber(), 'playing');
  };

  const startCountdown = () => {
    resetCountdown();
    countdownInterval.current = setInterval(onTick, 1000);
  };

  const onTick = () => {
    timeoutRef.current -= 1000;
    console.log('onTick: ' + timeoutRef.current);
    updateCountdownText();
    if (timeoutRef.current <= 0) {
      resetCountdown();
      modeRef.current = mode;
      onFail();
    }
  };

  const updateCountdownText = () => {
    const duration = moment.duration(timeoutRef.current, 'milliseconds');
    // const hours = duration.hours() < 10 ? `0${duration.hours()}` : `${duration.hours()}`;
    const minutes =
      duration.minutes() < 10
        ? `0${duration.minutes()}`
        : `${duration.minutes()}`;
    const seconds =
      duration.seconds() < 10
        ? `0${duration.seconds()}`
        : `${duration.seconds()}`;
    // setCountdownText(`${hours}:${minutes}:${seconds}`);
    setCountdownText(`${minutes}:${seconds}`);
  };

  const getModeNumber = (): 'easy' | 'medium' | 'hard' => {
    switch (modeRef.current) {
      case 'easy':
        return 'easy';
      case 'medium':
        return 'medium';
      case 'hard':
        return 'hard';
      default:
        return 'easy';
    }
  };

  const onStopBtnClick = () => {
    resetCountdown();
    changeMode(mode);
    isPlayingRef.current = false;
    load(current_photo, true);
    //
    sendAdvertize(getModeNumber(), 'stopped');
  };

  const onModeSelected = (new_mode: typeof mode) => {
    changeMode(new_mode);
    load(current_photo, true);
  };

  const onImageSelected = (image_src: any) => {
    setCurrentPhoto(image_src);
    load(image_src, true);
    setShowImageDialog(false);
  };

  const resetCountdown = () => {
    if (countdownInterval.current !== null) {
      clearInterval(countdownInterval.current);
      countdownInterval.current = null;
    }
  };

  const onSuccess = () => {
    const md = getModeNumber();
    resetCountdown();
    changeMode(mode);
    playAudio(require('../../assets/audios/success.wav'));
    isPlayingRef.current = false;
    setTimeout(() => {
      load(current_photo, true);
      //
      sendAdvertize(md, 'success');
    }, 2000);
  };

  const onFail = () => {
    const md = getModeNumber();
    resetCountdown();
    changeMode(mode);
    playAudio(require('../../assets/audios/fail.wav'));
    isPlayingRef.current = false;
    setTimeout(() => {
      load(current_photo, true);
      //
      sendAdvertize(md, 'fail');
    }, 2000);
  };

  const load = (image_src: any, preview: boolean) => {
    // const auto_gen = new headbreaker.Canvas('puzzle', {
    //   width: 800,
    //   height: 650,
    //   pieceSize: 100,
    //   proximity: 20,
    //   borderFill: 10,
    //   strokeWidth: 2,
    //   lineSoftness: 0.18,
    //   painter: new headbreaker.painters.Konva(),
    // });
    // auto_gen.autogenerate({
    //   horizontalPiecesCount: 2,
    //   verticalPiecesCount: 2,
    //   metadata: [
    //     { color: '#B83361' },
    //     { color: '#B87D32' },
    //     { color: '#A4C234' },
    //     { color: '#37AB8C' },
    //   ],
    // });
    // auto_gen.draw();

    // const auto_gen = new headbreaker.Canvas('puzzle', {
    //   width: 800,
    //   height: 650,
    //   pieceSize: 100,
    //   proximity: 20,
    //   borderFill: 10,
    //   strokeWidth: 2,
    //   lineSoftness: 0.12,
    //   painter: new headbreaker.painters.Konva(),
    //   image: photo,
    //   // optional, but it must be set in order to activate image scaling
    //   maxPiecesCount: { x: 5, y: 5 },
    // });

    // g.adjustImagesToPuzzleHeight();
    // g.sketchPiece({
    //   structure: 'TS--',
    //   metadata: { id: 'a', targetPosition: { x: 100, y: 100 } },
    // });
    // g.sketchPiece({
    //   structure: 'SSS-',
    //   metadata: { id: 'b', targetPosition: { x: 200, y: 100 } },
    // });
    // // ... more pieces ...
    // g.sketchPiece({
    //   structure: '--TT',
    //   metadata: {
    //     id: 'y',
    //     targetPosition: { x: 500, y: 500 },
    //     currentPosition: { x: 570, y: 560 },
    //   },
    // });

    const photo = new Image();
    photo.src = image_src;
    setReload(true);
    photo.onload = async () => {
      setReload(false);
      await waitFor(500);
      const g = new headbreaker.Canvas('puzzle', {
        painter: new headbreaker.painters.Konva(),
        width: window.innerWidth,
        height: window.innerHeight - 120,
        pieceSize:
          modeRef.current === 'easy'
            ? 100
            : modeRef.current === 'medium'
            ? 80
            : 60,
        // snapping each other
        proximity:
          modeRef.current === 'easy'
            ? 30
            : modeRef.current === 'medium'
            ? 25
            : 20,
        borderFill: 10,
        strokeWidth: 1.5,
        lineSoftness: 0.18,
        image: photo,
        strokeColor: 'blue',
        // for rounded joints
        outline: new headbreaker.outline.Rounded(),
        // preventOffstageDrag: true,
        fixed: true, // not canvas draggable
        // optional, but it must be set in order to activate image scaling
        maxPiecesCount:
          mode === 'easy'
            ? { x: 10, y: 10 }
            : mode === 'medium'
            ? { x: 20, y: 20 }
            : { x: 30, y: 30 },
      });

      g.adjustImagesToPuzzleHeight();

      switch (modeRef.current) {
        case 'easy':
          g.autogenerate({
            horizontalPiecesCount: 4,
            verticalPiecesCount: 4,
          });
          break;
        case 'medium':
          g.autogenerate({
            horizontalPiecesCount: 8,
            verticalPiecesCount: 6,
          });
          break;
        case 'hard':
          g.autogenerate({
            horizontalPiecesCount: 10,
            verticalPiecesCount: 8,
            // insertsGenerator: headbreaker.generators.random,
          });
          break;
      }
      if (preview) {
      } else {
        // randomize
        // g.autogenerate({
        //   insertsGenerator: headbreaker.generators.flipflop,
        // });
        // make it shuffle
        // g.shuffleGrid();
        g.shuffle(0.9);
      }

      g.draw();

      g.onConnect(
        (_piece: any, figure: any, _target: any, targetFigure: any) => {
          if (!preview) {
            // play sound
            if (canPlayClickAudio.current) {
              canPlayClickAudio.current = false;
              playAudio(require('../../assets/audios/click-2.wav'));
              setTimeout(() => {
                canPlayClickAudio.current = true; // allow to play again
              }, 250);
            }
          }

          // paint borders on click
          // of connecting and connected figures
          figure.shape.stroke('yellow');
          targetFigure.shape.stroke('yellow');
          g.redraw();

          setTimeout(() => {
            // restore border colors
            // later
            figure.shape.stroke('black');
            targetFigure.shape.stroke('black');
            g.redraw();
          }, 200);
        }
      );

      g.onDisconnect((it: any) => {
        if (!preview) {
          if (canPlayClickAudio.current) {
            canPlayClickAudio.current = false;
            playAudio(require('../../assets/audios/click-2.wav'));
            setTimeout(() => {
              canPlayClickAudio.current = true; // allow to play again
            }, 250);
          }
        }
      });

      if (!preview) {
        // validator
        g.attachSolvedValidator();
        g.onValid(() => {
          if (!preview) {
            resetCountdown(); // do it immediately
            setTimeout(onSuccess, 1500);
          }
        });
      }
    };
  };

  const playAudio = (src: any) => {
    const audio = new Audio(src);
    audio.muted = true;
    audio.currentTime = 0;
    audio
      .play()
      .then(() => {
        audio.muted = false; // Unmute after playback starts
      })
      .catch((error) => {
        console.error('[Main]: playAudio: Autoplay failed:', error);
      });
  };

  const sendAdvertize = (
    level: 'easy' | 'medium' | 'hard',
    status: 'playing' | 'stopped' | 'finished' | 'success' | 'fail'
  ) => {
    // send to ReactNativeWebView
    try {
      if (
        window.ReactNativeWebView &&
        typeof window.ReactNativeWebView.postMessage === 'function'
      ) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: 'vending-game',
            payload: {
              game_type: 'jigsaw',
              level,
              status,
            },
          })
        );
      }
    } catch (error) {
      console.error('[Main]: sendAdvertize: Error:', error);
    }
  };

  const ModeDialog = () => {
    return (
      <div
        className='mode-dialog'
        id='mode-dialog'
        onClick={(e) => {
          if (e.target === document.getElementById('mode-dialog')) {
            setShowModeDialog(false);
          }
        }}
      >
        <div className='mode-dialog-content'>
          <div className='mode-dialog-header'>Change Mode</div>
          <div className='mode-dialog-body'>
            <button
              className='mode-dialog-btn'
              onClick={() => onModeSelected('easy')}
            >
              Easy
            </button>
            <button
              className='mode-dialog-btn'
              onClick={() => onModeSelected('medium')}
            >
              Medium
            </button>
            <button
              className='mode-dialog-btn'
              onClick={() => onModeSelected('hard')}
            >
              Hard
            </button>
          </div>
          <div className='mode-dialog-footer'>
            <button
              className='mode-dialog-close-btn'
              onClick={() => setShowModeDialog(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    );
  };

  const ImagesDialog = () => {
    return (
      <div
        className='image-dialog'
        id='image-dialog'
        onClick={(e) => {
          if (e.target === document.getElementById('image-dialog')) {
            setShowImageDialog(false);
          }
        }}
      >
        <div className='image-dialog-content'>
          <div className='image-dialog-header'>Change Image</div>
          <div className='image-dialog-body'>
            {photos.map((p, i) => (
              <div
                className='image-dialog-image-lay'
                onClick={() => onImageSelected(p)}
              >
                <div className='image-dialog-image-top' />
                <img className='image-dialog-image' src={p} />
              </div>
            ))}
          </div>
          <div className='image-dialog-footer'>
            <button
              className='image-dialog-close-btn'
              onClick={() => setShowImageDialog(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className='main-lay'>
      {showModeDialog && ModeDialog()}
      {showImageDialog && ImagesDialog()}
      <div className='puzzle-lay'>
        {!isPlaying && <div className='puzzle-top' />}
        {!reload && <div className='puzzle' id='puzzle' />}
      </div>
      <div className='header-lay'>
        <div className='header-left'>
          <div
            className='header-image-top'
            onClick={() => {
              if (isPlayingRef.current) return;
              setShowImageDialog(true);
            }}
          />
          <img className='header-image' src={current_photo} />
        </div>
        <div className='header-center'>
          <span
            className={`header-timer${
              timeout <= 1000 * 10 ? ' header-timer-red' : ''
            }`}
          >
            {countdownText}
          </span>
          {!isPlaying && (
            <button onClick={onStartBtnClick} className='header-play-btn'>
              Start
            </button>
          )}
          {isPlaying && (
            <button onClick={onStopBtnClick} className='header-play-btn'>
              Stop
            </button>
          )}
        </div>
        <div className='header-right'>
          <span className='header-mode-title'>Mode</span>
          <span className='header-mode-text'>
            {mode === 'easy' ? 'Easy' : mode === 'medium' ? 'Medium' : 'Hard'}
          </span>
          {!isPlaying && (
            <button
              className='header-mode-btn'
              onClick={() => setShowModeDialog(true)}
            >
              Change Mode
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Main;
